import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { meApi, loginApi, registerApi, logoutApi } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);   // null = checking, false = guest, object = user
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // If returning from Google OAuth callback, let AuthCallback handle it first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const u = await meApi();
      setUser(u);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (data) => { const u = await loginApi(data); setUser(u); return u; };
  const register = async (data) => { const u = await registerApi(data); setUser(u); return u; };
  const logout = async () => { try { await logoutApi(); } catch {} setUser(false); };
  const refresh = async () => { try { const u = await meApi(); setUser(u); return u; } catch { setUser(false); return false; } };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
